import styled from 'styled-components';

import BoldCross from '@paradigm/design-system/src/assets/BoldCross';

const BoldAddIcon = styled(BoldCross)`
  transform: rotate(45deg);
`;

export default BoldAddIcon;
